export default __webpack_public_path__ + "static/media/regulatory--detour-left--g1.65da6dd7.png";